import React from 'react';
import createReactClass from 'create-react-class';
import {DialogTitle, DialogBody, DialogActions} from 'modules/notifications/components/dialogComponents';
import {Form} from 'modules/form';
import MyAccountOverviewItem from './myAccountOverviewItem';
import {Loading} from "uiKit";
import showErrorDialog from "../helpers/showErrorDialog";

var planOptions = [{
    "value": "single",
    "text": "Individual",
    "description": "<b>Individual</b>: Perfect for individuals",
    "annualDescription": "<b>Annual savings</b>: Save 25%"
}, {
    "value": "small",
    "text": "Small group",
    "description": "<b>Small group</b>: Up to 5 users",
    "annualDescription": "<b>Annual savings</b>: Save over 40%"
}, {
    "value": "medium",
    "text": "Medium group",
    "description": "<b>Medium group</b>: Up to 15 users",
    "annualDescription": "<b>Annual savings</b>: Save 60%"
}, {
    "value": "large",
    "text": "Large group",
    "description": "<b>Large group</b>: unlimited users",
    "annualDescription": "<b>Annual savings</b>: Save nearly 70%"
}];

var discountCheckTimer = null;
var paceyCheckTimer = null;

var SubscriptionDialog = createReactClass({

    getInitialState: function() {

        var convertedSubscription = this.getConvertedSubscription();

        return {
            subscriptionPlan: 'single',//convertedSubscription.plan,
            subscriptionType: 'standard',//convertedSubscription.type,
            subscriptionTerm: 'annually',//convertedSubscription.term,
            subscriptionTypeTogether: false,
            subscriptionEditors: 1,
            subscriptionQuantity: convertedSubscription.quantity,
            hasError: false,
            discount_code: '',
            discountOk: false,
            discountWrong: false,
            discountType: '',
            discountAmount: 0,
            checkToGetDiscount: false,
            isDiscountSyncing: false,
            paceyPostcode: '',
            paceyId: '',
            paceyForm: false,
            paceyOk: false,
            paceyWrong: false,
            couponFromResponse: '',
        }

    },

    componentDidMount: function() {

        _.map( this.props.options.subscriptions, ( sub ) => {
            if( "monthly" === sub.term
                && "single" !== sub.plan
                && "small" !== sub.plan
                && "medium" !== sub.plan
                && "large" !== sub.plan
            )
            planOptions.push(
                {
                    "value": sub.plan,
                    "text": "Other (" + sub.plan + ")",
                    "description": "<b>Other</b>: " + sub.title,
                    "annualDescription": "<b>Other</b>: " + sub.title,
                }
            );
        } )

        // Check Kinderly Together
        const userData = {email: this.props.options.user.email};

        this.setState({isDiscountSyncing: true});

        this.props.options.checkExistingMembershipInKinderly(userData)
            .then( resp => {
                const { success, is_pacey = false } = resp.data;

                if (success || is_pacey) {

                    this.setState( { subscriptionType: 'together' } );
                    this.setState( { subscriptionTypeTogether: true } );

                } else {

                }
            }).catch( (e) => {

        }).finally( () => {
            this.setState({isDiscountSyncing: false});
        });
    },

    paceyCheck: function() {

        if(!this.state.paceyId || !this.state.paceyPostcode) {

            return;
        }

        this.setState({isDiscountSyncing: true});

        clearTimeout(paceyCheckTimer);

        paceyCheckTimer = setTimeout(() => {
            this.onPaceyCheck();
        }, 1000);

    },

    onPaceyCheck: function() {

        if(!this.state.paceyId || !this.state.paceyPostcode) {
            return this.setState({
                paceyOk: false,
                paceyWrong: false,
                isDiscountSyncing: false
            });
        }

        const data = { pacey_id: this.state.paceyId, postcode: this.state.paceyPostcode, surname: this.props.options.user.lastName}

        console.log('Checking PACEY with surname: ' + this.props.options.user.lastName);

        this.props.options.checkExistingMembershipInPACEY(data)
            .then( (resp) => {

                if(resp.content) {

                    // Confirm PACEY subscription
                    this.setState( { subscriptionType: 'pacey' } );

                    return this.setState({
                        paceyOk: true,
                        paceyWrong: false,
                        isDiscountSyncing: false
                    });

                } else {

                    console.log( this.state.discountAmount );

                    return this.setState({
                        paceyOk: false,
                        paceyWrong: true,
                        isDiscountSyncing: false,
                        subscriptionType: this.state.subscriptionTypeTogether === 'together' ? 'together' : 'standard'
                    });
                }
            })
            .catch( (e) => {

                return this.setState({
                    paceyOk: false,
                    paceyWrong: true,
                    isDiscountSyncing: false,
                    subscriptionType: this.state.subscriptionTypeTogether === 'together' ? 'together' : 'standard'
                });
            });
    },

    // onPaceyIdChange: function(e) {
    //
    //     this.setState({paceyId: e.currentTarget.value});
    //
    //     this.paceyCheck();
    // },
    //
    // onPaceyPostcodeChange: function(e) {
    //
    //     this.setState({paceyPostcode: e.currentTarget.value});
    //
    //     this.paceyCheck();
    // },

    handlePaceyChange: function(update, hasErrored, fieldKey) {
        this.setState(update);
        this.paceyCheck();

        var updateObject = hasErrored || {hasError: false};

        updateObject[fieldKey] = update[fieldKey];

        this.setState(updateObject, () => {

        });
        return Promise.resolve(update);
    },

    onPaymentChange: function(e) {
        this.setState({subscriptionTerm: e.currentTarget.value})

        this.discountCheck();
    },

    onPaymentPlanChange: function(e) {
        this.setState({subscriptionPlan: e.currentTarget.value})

        this.discountCheck();
    },

    onDiscountChange: function(e) {

        this.setState({discount_code: e.currentTarget.value});

        this.discountCheck();
    },

    discountCheck: function() {

        if(!this.state.discount_code) {
            return;
        }

        this.setState({isDiscountSyncing: true});

        clearTimeout(discountCheckTimer);

        discountCheckTimer = setTimeout(() => {
            this.onDiscountCheck(this.state.discount_code);
        }, 1000);
    },

    onDiscountCheck: function(discountCode) {

        if(!discountCode) {
            return this.setState({
                discountOk: false,
                discountWrong: false,
                isDiscountSyncing: false,
                discountType: '',
                discountAmount: 0,
                discount_code: ''
            });
        }

        return this.props.options.getCoupon(discountCode, this.state.subscriptionTerm)
            .then((response) => {
                this.setState({
                    isDiscountSyncing: false
                });

                if (response) {
                    this.setState({
                        couponFromResponse: response.coupon
                    });
                }

                if(!response) {
                    this.setState({
                        discountOk: false,
                        discountWrong: true,
                        discountType: '',
                        discountAmount: 0,
                        discount_code: ''
                    });
                } else if('each_specified_item' === response.coupon.apply_on && 'all' === response.coupon.plan_constraint && 'active' === response.coupon.status) {

                    this.setState({
                        discountOk: true,
                        discountWrong: false,
                        discountType: response.coupon.discount_type,
                        discountAmount: ('fixed_amount' === response.coupon.discount_type) ? response.coupon.discount_amount : response.coupon.discount_percentage
                    });

                } else if('each_specified_item' === response.coupon.apply_on && 'specific' === response.coupon.plan_constraint && 'active' === response.coupon.status) { // If discount code is limited to specific plans

                    if(response.coupon.plan_ids.find((elem) => { return elem === this.getPlan().plan_id; })) {
                        this.setState({
                            discountOk: true,
                            discountWrong: false,
                            discountType: response.coupon.discount_type,
                            discountAmount: ('fixed_amount' === response.coupon.discount_type) ? response.coupon.discount_amount : response.coupon.discount_percentage
                        });
                    } else {
                        return this.setState({
                            discountOk: false,
                            discountWrong: true,
                            discountType: '',
                            discountAmount: 0,
                            discount_code: ''
                        });
                    }
                } else if('invoice_amount' === response.coupon.apply_on && 'active' === response.coupon.status) {

                    this.setState({
                        discountOk: true,
                        discountWrong: false,
                        discountType: response.coupon.discount_type,
                        discountAmount: ('fixed_amount' === response.coupon.discount_type) ? response.coupon.discount_amount : response.coupon.discount_percentage
                    });
                }
            })
            .catch((e) => {

                this.setState({
                    discountOk: false,
                    discountWrong: true,
                    discountType: '',
                    discountAmount: 0,
                    discount_code: ''
                });
            });

    },

    onCheckToGetDiscountChange: function() {

        if(this.state.checkToGetDiscount === true) {
            this.setState({
                paceyOk: false,
                paceyWrong: false
            });
            this.setState({subscriptionType: 'standard'});
            this.setState({paceyId: '', paceyPostcode: ''});
        }

        this.setState({checkToGetDiscount: !this.state.checkToGetDiscount});
        this.setState({paceyForm: !this.state.paceyForm});
    },
    
    handleDialogAction: function(action) {

        var plan = this.getPlan();

        var plan_id = plan.plan_id;

        var plan_quantity = 1;//this.getPlanQuantity();

        let discountCoupon = '';
        let responseCouponId = this.state.couponFromResponse.id;

        if ( responseCouponId === this.state.discount_code + '_Y' || responseCouponId === this.state.discount_code + '_M' ) {
            discountCoupon = responseCouponId;
        } else {
            discountCoupon = this.state.discountAmount > 0 ? this.state.discount_code : '';
        }

        this.props.commitAction({
            action: action,
            payload: {
                plan_id: plan_id,
                plan_quantity: plan_quantity,
                term: this.state.subscriptionTerm,
                plan: this.state.subscriptionPlan,
                type: this.state.subscriptionType,
                discount_code: discountCoupon,
                coupon:  discountCoupon,
                checkToGetDiscount: this.state.checkToGetDiscount
            }
        });
    },

    onUpdate: function(update, hasErrored, fieldKey) {
        
        var updateObject = hasErrored || {hasError: false};

        updateObject[fieldKey] = update[fieldKey];

        this.setState(updateObject, () => {

        });
        return Promise.resolve(update);
    },

    // getPlanQuantity: function() {
    //     if (this.state.subscriptionType === 'standard') {
    //         return this.state.subscriptionEditors;
    //     }
    // },

    getPlan: function(forceMonthly) {

        if(forceMonthly) {
            return this.props.options.subscriptions['kl-' + this.state.subscriptionPlan + '-' + this.state.subscriptionType + '-monthly'];
        } else {
            return this.props.options.subscriptions['kl-' + this.state.subscriptionPlan + '-' + this.state.subscriptionType + '-' + this.state.subscriptionTerm];
        }
    },

    getDefaultPlan: function(forceMonthly) {
        if(forceMonthly) {
            return this.props.options.subscriptions['kl-' + this.state.subscriptionPlan + '-standard-monthly'];
        } else {
            return this.props.options.subscriptions['kl-' + this.state.subscriptionPlan + '-standard-' + this.state.subscriptionTerm];
        }
    },

    getTypeAndTerm: function() {
        return this.props.options.subscriptions[this.props.options.subscription.plan_id];
    },

    getConvertedSubscription: function() {
        var subscription = this.props.options.subscription;

        var convertedSubscription = this.props.options.subscriptions[subscription.plan_id] || {};

        if (convertedSubscription.type === undefined || convertedSubscription.type === 'standard') {
            var editors = subscription.plan_quantity;
            var quantity = subscription.plan_quantity;
        }

        convertedSubscription.editors = editors;
        convertedSubscription.quantity = quantity;

        return convertedSubscription;
    },

    getEstimatedPricing: function() {
        var plan = this.getPlan();
        var planMonthly = this.getDefaultPlan(true);
        var defaultPrice = 0;
        var calculatedPrice = ((this.state.subscriptionEditors * plan.plan_unit_price) / 100).toFixed(2);
        var reCalculatedPrice = calculatedPrice;

        if(this.state.subscriptionTerm === 'monthly') {
            defaultPrice = ((this.state.subscriptionEditors * planMonthly.plan_unit_price) / 100).toFixed(2);
        } else {
            defaultPrice = ((this.state.subscriptionEditors * planMonthly.plan_unit_price * 12) / 100).toFixed(2);
        }

        if(this.state.discountAmount > 0) {

            if(this.state.discountType === 'fixed_amount') {

                reCalculatedPrice = (calculatedPrice - this.state.discountAmount.toFixed(2) / 100).toFixed(2);
            } else {

                reCalculatedPrice = (
                    (
                        (
                            100 - this.state.discountAmount.toFixed(2)
                        ) / 100
                    ).toFixed(2) * calculatedPrice
                ).toFixed(2);
            }
        }

        var finalDiscount = (defaultPrice - reCalculatedPrice).toFixed(2);


        if (
            this.state.subscriptionType === 'standard'
            || this.state.subscriptionType === 'together'
            || this.state.subscriptionType === 'pacey'
        ) {
            return {
                'default': defaultPrice,
                'calculated': reCalculatedPrice,
                'discount': finalDiscount
            };
        }
    },

    getEstimatedPricingForStandard: function(editorCount) {
        var plan = this.props.options.subscriptions['kl-single-standard-monthly'];
        return ((editorCount * plan.plan_unit_price) / 100);
    },

    renderEstimatedSubscriptionPricing: function() {
        
        var estimatedPricing = this.getEstimatedPricing();

        var term = (this.state.subscriptionTerm === 'monthly') ? 'month' : 'year';

        var label = "Plan price (per " + term + ")";

        if(this.state.isDiscountSyncing) {
            return (
                <div className="my-account-overview-item estimated-plan">
                    <div className="my-account-overview-item-label">{label}</div>
                    <div className="my-account-overview-item-value">
                        <Loading text="" />
                    </div>
                </div>

            )
        } else {

            if (estimatedPricing.default !== estimatedPricing.calculated) {
                return (
                    <div className="my-account-overview-item estimated-plan">
                        <div className="my-account-overview-item-label">{label}</div>
                        <div className="my-account-overview-item-value">
                            <span className="strike-price">£{estimatedPricing.default}</span> £{estimatedPricing.calculated}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="my-account-overview-item estimated-plan">
                        <div className="my-account-overview-item-label">{label}</div>
                        <div className="my-account-overview-item-value">
                            £{estimatedPricing.calculated}
                        </div>
                    </div>
                );
            }
        }
    },

    renderEstimatedDiscount: function() {

        var estimatedPricing = this.getEstimatedPricing();
        var discount = (estimatedPricing.discount > 0) ? '£' + estimatedPricing.discount : 'n/a';

        if(this.state.isDiscountSyncing) {
            return (
                <div className="my-account-overview-item estimated-discount">
                    <div className="my-account-overview-item-label">{'Discount'}</div>
                    <div className="my-account-overview-item-value">
                        <Loading text="" />
                    </div>
                </div>

            )
        } else {
            return (
                <div className="my-account-overview-item estimated-discount">
                    <div className="my-account-overview-item-label">{'Discount'}</div>
                    <div className="my-account-overview-item-value">
                        {discount}
                    </div>
                </div>
            );
        }
    },

    renderEstimatedVat: function() {

        var estimatedPricing = this.getEstimatedPricing();
        var discount = (estimatedPricing.calculated > 0) ? '£' + (0.2 * estimatedPricing.calculated).toFixed(2) : 'n/a';

        if(this.state.isDiscountSyncing) {
            return (
                <div className="my-account-overview-item estimated-vat">
                    <div className="my-account-overview-item-label">{'VAT 20%'}</div>
                    <div className="my-account-overview-item-value">
                        <Loading text="" />
                    </div>
                </div>

            )
        } else {

            return (
                <div className="my-account-overview-item estimated-vat">
                    <div className="my-account-overview-item-label">{'VAT 20%'}</div>
                    <div className="my-account-overview-item-value">
                        {discount}
                    </div>
                </div>
            );
        }
    },

    renderEstimatedTotal: function() {

        var estimatedPricing = this.getEstimatedPricing();
        var discount = (estimatedPricing.calculated > 0) ? '£' + (1.2 * estimatedPricing.calculated).toFixed(2) : 'n/a';

        if(this.state.isDiscountSyncing) {
            return (
                <div className="my-account-overview-item estimated-total">
                    <div className="my-account-overview-item-label">{'Total'}</div>
                    <div className="my-account-overview-item-value">
                        <Loading text="" />
                    </div>
                </div>

            )
        } else {

            return (
                <div className="my-account-overview-item estimated-total">
                    <div className="my-account-overview-item-label">{'Total'}</div>
                    <div className="my-account-overview-item-value">
                        {discount}
                    </div>
                </div>
            );
        }
    },

    renderPaceyForm: function() {

        if(this.state.paceyForm) {

            return (
                <div className="discount-code">
                    <Form
                        schema={
                            {
                                "paceyId": {
                                    "type":"Text",
                                    "label": "PACEY ID",
                                    "validators": ["required"],
                                    "conditions": [],
                                    "help": ""
                                },
                                "paceyPostcode": {
                                    "type":"Text",
                                    "label": "Post code",
                                    "validators": ["required"],
                                    "conditions": [],
                                    "help": ""
                                }
                            }
                        }
                        onUpdate={ this.handlePaceyChange }
                    />
                </div>
            );
        }
    },

    renderTogetherInfo: function() {

        var description = "<strong>Existing Kinderly subscriber and PACEY member</strong> - discount applied!";

        if(this.state.subscriptionType === 'together') {

            return (
                <div
                    className="alert-info my-account-subscription-dialog-alert-info my-account-subscription-dialog-alert-info-pacey info">
                    <div className="alert-info-inner text-align-left">
                        <i className="icon icon-checkmark-circle"/>
                        <span className=" text-align-left" dangerouslySetInnerHTML={{__html: description}}></span>
                    </div>
                </div>
            );
        }
    },

    renderPlanOptions: function() {
        return _.map(planOptions, function(option) {
            return (
                <option value={option.value} key={option.value}>
                    {option.text}
                </option>
            );
        }, this);
    },
    
    render: function() {

        return (
            <div className="update-subscription-dialog dialog">
                <DialogTitle title={this.props.title}/>
                <div className="dialog-body" dangerouslySetInnerHTML={{__html: this.props.body}}/>
                <div className="update-subscription-dialog-overview">
                    <div className="payment-section">
                        <div className="payment-method">
                            <span className="my-account-overview-item-label">Select Payment Plan</span><br/>
                            <select
                                name="payment_plan"
                                id="payment_plan"
                                onChange={this.onPaymentPlanChange}
                            >
                                {this.renderPlanOptions()}
                            </select>
                        </div>
                        <div className="payment-method">
                            <span className="my-account-overview-item-label">Select payment frequency</span><br/>
                            <label htmlFor="payment_annually">
                                <input
                                    name="payment_annually"
                                    id="payment_annually"
                                    type="radio"
                                    value="annually"
                                    onChange={this.onPaymentChange}
                                    checked={this.state.subscriptionTerm === 'annually'}
                                /> <span className="my-account-overview-item-value smaller">Annually <span className="force-red">- save up to 25% when you select the annual payment plan</span></span>
                            </label>
                            <label htmlFor="payment_monthly">
                                <input
                                    name="payment_monthly"
                                    id="payment_monthly"
                                    type="radio"
                                    value="monthly"
                                    onChange={this.onPaymentChange}
                                    checked={this.state.subscriptionTerm === 'monthly'}
                                /> <span className="my-account-overview-item-value smaller">Monthly</span>
                            </label>
                        </div>
                        <div className="discount-code">
                            <label htmlFor="discount-code">
                            <span className="my-account-overview-item-label">Enter promotion or referral code</span>
                            </label>
                            <input
                                type="text"
                                name="discount-code"
                                value={ this.state.discount_code }
                                onPaste={ this.onDiscountChange }
                                onInput={ this.onDiscountChange }
                                />
                            { this.state.discountOk ? <i className="icon icon-checkmark-circle icon-for-discount"/> : null }
                            { this.state.discountWrong ? <i className="icon icon-cross-circle icon-for-discount"/> : null }
                        </div>
                    </div>
                    <div>
                        <div className={"pacey-kinderly" + (this.state.subscriptionType === 'together' ? " hidden" : "")}>

                            <label htmlFor="pacey_or_kinderly">
                                <input
                                    name="pacey_or_kinderly"
                                    id="pacey_or_kinderly"
                                    type="checkbox"
                                    value="pacey_or_kinderly"
                                    onChange={ this.onCheckToGetDiscountChange }
                                    checked={ this.state.checkToGetDiscount }
                                /> <span className="my-account-overview-item-label">I am a <div className="pacey-logo"><img alt="pacey-logo.png" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAA/CAYAAAClz4c/AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wMbCyYMWoFJLAAAIABJREFUeJztvXeYFUX2Pv6e6nDT3MnknAxkkRwURBBMKGLAFddVDKiYEyoqgmHXBIIKhtU1Y0ZUkiRRyTkJIjkOk+fG7q463z/uDDDMnZk7gO7+fp95n+c+M90V+nR1na46sYG/CMHNDxz5385a+Fddthr/x7Fxz4wy577e8PB/gZLjEFl+VZlzBQemaiX/F6677S+lpxp/Hu78eON/m4S4eHP5NaWOV+785sj8++fPvWFZOX8+EeHNj1VcvuKadOvn7j2tX/ufG1519SXRPyak/flUVQ2Hl+/4r14/vPp3FPpvSrh+4f0f/InUHMXF45dVWL5py35x/Lmznl5U5eu8vuzyUscv/nIumLnK/ZSHycsGnzlx6cA7JiwZ+PSrSwaOem3ZkFYA8NxPXcjm7Arb0olelEO7Yf3cnVz99/JOZq3Ooi5nkp1/AUhzsbu2qQV37mNGbTb857K71ibWfLtgeNpT6IAG3T8fhncze5v+4T7juQMAEJh3Gnx9loLoz+efWd0m4ILFd8ctWzhiiod+p2QnaHt0YRoy4jhRlxNOq5uOvA1Z3WCrVgwEhSnyoFAPStXQk13fa8neeVqmI3t9fktCNIQnzoRn5IBS55hZy7n29daUFfBqgmqzksnKdtKIqRAeYxc6Nd6eNu6qHUSxx3b43Xmo8Y/zTm4wEkDv5xc1CEftmjlhdZ6uCUcxU5JLP+hI26cJ3fbpcl/7prWWT7q2dT4AoM3HwPprE+o7O7QVmd7TAACTlw/pBvDe2zp9uedU0D152RUk2b7WksFRAJ/OYB0ASOgr3cL34IjO38wHgKlr7sPV7V+O20eVGcQ+8AWMOkOOHFsL2t9JKjJSmekzASONDH+aKNp0HskwAzBAwgSoAOAISPMxKy+IAkyuXKV5CqF5V9v+phOSzvpkNQOI7PgXPE0eOpHxqBTzL34Lfb67+cjx7A4TLlBF8hoQzlQRmQaCBhz7IwKYAajYULEfgAcMBYIDwARgkhBBs5bZsu+SkbsToSNr1Ieo+dx1AIDA90sznQ+W3Ch35l8igtG6LJUPDAGCWUyHDsAhIMouvYg8xnqcWXda9NK2U2sP6hIAgL2LVqF+rw6nZIyaj5qFbc9dAAA4e/SMRoci2i1hW3VhxW4CpYDAzGAQHAJrLkOEkk3aLFko25FLz6jre2/mvT2dRK7FnId7ZrTAhAuzMWnpxWNtGe1nCt/wO7p+s2HSLxfhzh7fn/B9bM36CdO2PqaZmmeDZPt0ANYxxUIjfXGrjEuHkmMe7NvyVlVePye0gjAzRbO/rCm2jH+UydBgZmSTndOZotltycmtS0om3i8JKJEUlO6617p7LvgWAMIL28N9zq8g8p4IeWWw7MmZ2PfPX3B5ZCwWDH6nvtwXPsvOjYxTUW4LgHESK2kJyGe8MHDzPQ8d+mUHavVoErdO/tUTkDo1tnJlPfbRGcbsLXdTVA5nqTSWKiEaCACbGvR2DUbJIW0nrr+0e+gcIi745CekDD3npO6h8YMzsfOFAWg+alaLojC/EFXqdDCVO3mOgEGCSAkBV20fvVrHx68X6mly6cNdErruxCUXvWqp4EgBrUAXrn+M7PrD1yd1I8X4/rex7q25C8IMFT2+jEjAIPcPzPKOkd1mHiivj0ofCnM2QosHwdf9FziHpuoyf4uXI7tbMuzOIri/pgjvOUfYeb1AJfPsROYagyHAZo2NSvc+QK5ac83O0+zI7IZw90/opVwG8y//N/p8fSMA4MezxrsBzW07zt2c7zx18uxQFqQLq94tZyS1feQi+/iy7FajkLnxOQBAwd9fr+VsO/xvisiBFIgQU9WJIWYorwlBiFLTjIfVeS3fC90+pbA+vqryxr3t6FlYNza2Ypz+0A9aWIm/FVl4kpktAJUzxzFgQHNpItAgwzt05ehevyfS5rWlg0ZGZcGrAEUZrAvoBz16cv/bOn+16Y3ll2NEpxPnlX8v+3uLfGfXVoDKMAgAjUjsSTZqjzi7xuC57Rtd4YSc/fDqdUtVKiNkHY/IrO7wdf8FgTVXpqsD31+DwMZrENreRz/8801a0brHhJPXC0TFXZ3ozCMQGMI63EqLZH2JwO8vRH49v6G7/26E5zUHc36Vept/yZtHmGNuh9eaOSH1tF0Q3YSCP4c5AAA2mwc/2zrw+NPZX/9yhDny+zzbWf2R/Tnlhy/ECTIHADARKGSDw7aL9xQ+wh8sedZ3Ra8OvCX7iJbmwF1vJ9RXCXO0eHhOZoFNTxVE8SQzR1BF5gAAAoiBnZqyulVUr0S7NGX55W0tVTS2ZAITyGE49aIyOPqtVUOTRnT6Gh+viC8rJoIo59Xn8h+4ZFb1bY4+vDe47gwAGD27a5lKFTKIdfgreAZsBQBokq/hom1PU+HGa/Si3+8WMtCWTnjFKAEf8wOYdMUkTJJFd2vBPz4Mrrikqee8bbB+aAAObqu0t3XjvsE3KePQZ3pMUJ7VZsJwKz/ysYrIB9nhOqdOLxLnToihguri48/T49MBALk9x16pckNfcXawFyTHxJuTAQFggPODtakgPAK7814vuOudJ3JGf9IEADI35FbaxYTpy5F58zto/dis5vlR9VTYwVUEjve2TRSOo1S7gwHn0vvfnOcqr9ItnT4FAISdotHM7D7uxqKSrWvC0dwXAeDajhNOmBhNaBahoqfOHHEKehwO/zH47RXXJ790YdndSsUryKLBAAB7Ua+hev7ah7TwngbCzutNbNU62W07kw6lp+UozV+oRFKQhcchFRYkwzprvgNChnuZ+Zu/iC4fcpbroiLYC9pV2N/s3q+i7eOX4bKCxzGnx6R2M5q8OEMW2S+zozpXOEanEMSi0bHHec98hYyNzyNnwD9vRF7oTUTteqf+ogQoJi6MdpaHih6lzYcvKLj5rf7GvIeQc+97FTa9e8w2zLy9k5EXxmhbqr4ESODkRksx7GBUtZm7x+5ZUb3Xl17ekZnbI/5Eijps3/Tm0isSE2LKA6ucildpYsm2EbRz+0kZah2vRrkMEt14G8zBQHTZZQ3Jzr5fOIFGxLZOLOkUyLQgdiCcwjQhg0lCBb0gikhP442suXNARgqEYCEDZ+n5y96yVg5taF4UBHP5b8X+C+4CAMxs9dJVzv7ILJY8AIr9J01oovcDBgSO7LtznvsKaY8NRgFH3JQdfBGOSv3TaVAyQhv3v+ys3PkMAGS8ckO59oSmD88AVgzFpR8e+Cxoq66IbalO+lVCADsM3e12G/HK1xyYBgBwVLAnwPXKvyarqAreAAC/7n7jhGgx9WStslsikOOw1dzjStHilZfLIK5WkwEAWtFvf4dT1OEUjF0cKAGwABQxS7di21HeJt+QsnLAxVoddtpR/oohAECUHreX93Ar1r70Hc1q/Uo/FVQfsuRafwKxFYIBiGTzAwCIMCNjVGz1lVdN+YiKImkn8U6RIETh0hbBa46hjKTBWsOMHpzq6i5SfZeSz3wbmigCGHAZf7DfLBQhp0VO76evBAA67g3KHAYAbP/nQDR9eMbFUcmtiCCrRE+lKw3BYOtgvJL2dQYBABRUXQZ7KrgO2+ycCwDdG46oAnlHEVTZNYgrFbOVYqe27YQ6xSvUK2oZXX9XA85d1Fs4BSfweAUAOICq8BoldYWK6MLKaeAA2az7I7ALGcQEVjqBu0Y2jva5W40NHt/yx7Mn4PyVd2PuZ22bcUS9DwnjTxPEKwAZena/ZXcsnZ78NIJ0PgAg74oJg3njgQFMBBApcOVP62iHUBBiG3nN8c5FLf9T46mrQ+XUnH7gtvH3matzbxJB+2KV7N6CBmkvQdm/AQAzl2ISotic7DRmdt29Beo+R7JDlbz9GNAFoUgQNhsazfCZGgUtdX3EVvXj1dcEZNBCRnn9rV72hpgvP/ejkusqkqnvLx/e+PpOb+9kzgJRzYqqlwEprx8Io/IdD8mAk3shgDLWwnInr8VMvPTCdmQXto+tvonNOiYjF1rSHqUnrSIZzAW4MymrGalIXbCN8lXBBLBMFTLUCOB00NFKrKyalP1DKoBSDDK35+vo+/PtWNB7UkZkf3Sqiqra/w3mAADS8DkAnDF7KDK6PgEAULtzbxCKvSyI4TFyEbIzkYgLBcFil/6OU8c7ttaMxw5gOZBz4b+Q8UNZA2p27zHInHxPEYDxxb8jyOkztswKUoKo1C6WLM1KhosASLeO34UQ7x946YLPAKDjmLld8yMSiL0Fy2i7BKBBx9byOrUMnYQkUpXsSgTDLHD2dQSws6rMAQDMtp3gvJXM3DwuDfE7thDd/rQO63A7yFB61WQO9oLIS7p/P2veXay5DyhXjdXS2+QjadZax8K9EVyeBpGFcIqaCyeYfvTlQmDSFGtcighmRt+fbwcARLKsl1RYdvhvMQeYofmNBQDQomsLAEDghenJZMnTGAAMLQqGCZXQNpXh0r/cs3rcHbVmPHYAAA5f9mJc5gCAzAVPlttRxvzR5Za5DShLUmVvcc1r0E9tahoPljDHBc/PbXag0LlESq6HOMyhGC6PQctX/m323vI67XLWzRJEFiqdWOQG0AEARs+pW3HVOFCIlLfqHg9WbMflwLgMQmTCODgvmZzAZZSwOpzBJBzWPO+A7SsRyZpITvR9Ed57D0H93UntOlYltVgsvQ3WSk/975hEtPxnU/o8CfcBzrgs79hzX2kxJ8lZrcbfokLyqlOlbSYAJFAlVacwNWiGvgoADi7bBABwLMuHZHcRAYAQArrYkYgcx7oo0NvUG9meiHN6jQEA1PjmgUpaVR27851OYI4rSBdDI2C719Qm/Tjq/M0AMHzyT7W35joDgzYPQjlzx9AItZO056jZC9z1yfJdRZg5gcnLhoR9OgCM7be/8urHgdhoWZX6n6+6q4yWsdw9sW7n+YUT6Jj41so8KJM7XOW4632syBjKmv4sk/xZ+hq9rhh3UmR3PZnW625iHGRPgy3S02gzk5HYRCStOUU31yk5nN3pZVyhnsXiy95LVyFnBBQqEvbKdkcEMihIAhFhUERL0vaa6a69Rh3PF1qKeTsEfZVwZwxobv03zaPnAUDtzi2Lx8O2KRh1MQASWEOWbFD5CxOgVM/05A9uzwGAjEXlrw4nghKNVuMHZ58RsdUZqIBjBSHid+ufb3u+3+bXJ06gzZvWuWb/ERmSF1b3gJnitWXA4zXom4jEZgBYMuaicmkR0PMBssqtEAMp5rQZq+6vks9RyX1KtgcBiSogmLKcXWU0jeXKIGykppBVubEJAEBaRJoZv1Dhupt10iJKc33qJLVa7Ov40Z7o+kfdlPP9ED1v6URl585RSQ2/FYHdt4rQ/jTpqjlTtw71BMtyBTqAQcoxKZSrA0eFznn9xvvyN+a8w4rbJ0SiIGlkuhYIl3YouVXGdwwRKPwtpxsZtJRYW9dn3vAdADC79csZxLisKjo7MsUPZroRKCUQb8ltwI70gwGkeeqq3fnpJCphEAXA1L8EgIBlIck0q0BFAnQW02YzOhKRvyKXcgbyGmXos3cx05DxC+qNeWv/oxEHAykmB8YVIg1B4WS3/v76sX3LnfglY0SggwQEGaho8jOAmn9YW5sDWPfrnkno3uDOhO+TgfZImEEAElQLQKnglvIZJJpzsYBAIr58TFpYyLAbetJk47xN38bO/gYAcLV5NgLgQwAfWvO8F5ATvEAa3myV1HCxFs1tq7wtPqXwjl5geSaxE3/JV5Emwspunl+06Tdr91oAgDyAtqTQpVKZlyB1j7HZ1cQ3NaNj3a9Duwu8omPGxg63nB8CML1MfU1PZmGnQSbKIgzh0Q/WuLiFLCUQ54SbQrKfCOA9BfUrZY4YrdAkdgE45cxxLFiphmD2oHx3EvLoYu2Q9jUPN3hg5rCwQ7dLRjqBQyhnMghCOMlF79byyS0VhU+VjJGma9ukg3wwfKhgr03g+pKtdgDWJcIcJVj5+5uehYc/yUDCLjPEESdQZv6Vr3ZklaR0d0JCDinHBTKPMIf1S69S5dYfb8C6GTDP2zzL7LX4Ydih90Q0OwhgjeJwGye5/WRlZs4rjxFJhVPIznk0aeXfU+Ty2IKhJ5uKdLIr5l2G5tIWuNukDz13xs3jWo+9aGPn/1y7vMMt54dWPD4tbgsVke4qGRiJIEPO7ub/6HHExZuZQRoZMQcUJKzjYE2wdJw/NSDm6td/NW2FGhW9WBhAkluz/zVn7+sBG49LxalgLuOEeQzI59J+vbZ92nvzRvWPth09u1I6kn0tV4MR11ZSmhZOYfDplXZ4HJblzujMFfuZHA8iFhJAKeNqGQZhjtEsOCpRgafXMS2g9KSpxnnrvwOA8MYnYPYoHVVmNhsB862jx55ei5eDzGdYuKNKuKZpgU0PEMtCJr3ch0Aq2k1xYRfvEGB261dr20X2cyC4KjZXEeDR3zvn8+s3AMAP576CyNLY/XUcNyh+G43cIKqSBZ649DjmPTjVrfLC/gQcxUv3Q+TArZ1VtVZVw+o9gUaK0QIVsC0ByA06/YKW6g6Gg0q2KZqgvDp+/dNnr+0cAIB1Y/tXSsewli8EBWnbUPkbngFuNWXp4MxKOwXwyZqYUdFW4cupirZtg7TTgdLG1TIMQlQbzExOaod8kkFV6euPGZa3zjMAEP2lOzytnq6wemRxPwCA2WftDnjqPq6HD1wnnFBTYWVfSuyU3fKRZivhDQESJO3rmBnCpwm2VWMZkhVbzBkgpWoBwPyrp+DChffC3aV2hU1Ii22QK6xU+hJgIu3Yt47+2x9MLi2dNTq6T0pki+VIA1FZFwDsUxhyChx9KwYiysUMExWr1NhRbCAx9xNBQLBhir4OANo+PidhmghiJYCKViYAsJllnyiHmybS59D2MbcUyfYFqJr7BzHDffzJcrdYQkbbQVQ6jmA9KeLrtvAPAHD1+BV86NsKqXB3iw3gIWaYXabvB+TSYs8FF8BlZhFDC0Iz9wMAQWsHAOcvvWO/MPWbhaGVsayXakuACjrDAaDP1Fvx04XvVUgbAMigZbGjEtWfxyxpwah/yaDJR8Yy+bvHogqIAIjtaYmQsGu7Jc8EAONkvX2Pp7O4P0XIADgNp8TvioQpeHv2hAH9v7j7nKLWj/+IdeP6VdquhFl1w78IpSP94lZX4BRmefkbiweVK5gd+4J6Y8nl/RU4oRXnGChhmGuO76sMg0TzZ4KIGOAZUFFXRStIbH/tnnTsOap1KQAgsPIyw17QPiW6oF1SdOkVZmTjk3pWTD2IwB8TtbT57fzWvJbpIFGxCo9YsfAcUGQ40tfoSIR95oDGWzSvsaqyx6ykajCz7YS/AcA5P9yA+YPeqbC+5jMDQhNVSndBzGeGdoTMohX7cLB4cCnFXA9N5EATjJhMYkFUvumiwsgFuX2eva7kuOicsVUhpVwUBGMadamQASATlTCIriHbbdIaU6cVhkbbEQv/ZQJCBOQDlJfpE8+keoy7AeDeD1dhw7jzE6KlhFlHnP35aiJRqaqUAJuhbmOBmgDw+dqyRtNnFsZCjlfveEePqsBIAicnRAwAgCHICMOxzGPpA+IwiCt1AKYxAzLcgVScLU9pwqE4ugQAQmv+7rPnnt7e/rHRec6cxkPceWsfJafgLc0ueE0rWvuEfvDjB9MXtL5Tzj9zuHvnhPuELHxdOIF1wglcX+E1mB2wk0VkhIXw+kuIL1h9MF3ZTuX+B0w+Dth3/9h7Sl0A6DPtJsy/5r0y1XZ/tRoAYDTzZiE2IRKGAvVRpLt+6DoJtYvpi7TOXEp1kr8ml2Gx27AAEkggQI0BDYcKXz3cc0wfAPD/VL41vCpI8cXCM6SCUJXLlpzs0v4zfWjNm7JeGfD3ZDePYvB0XaePXbp4Lsml3dOxtj3w9+f7f7j1+X7bmj40G69cV7WY+Im/DAIRsUskfQNwXE/aY6AkO6mOit4BAFe2+xfeXlY6KcTjvWPP7+esL4cxZPcqkCKEcOV59ZQ5pubZdXxhXAa4YPUNDSADHSvrmUHQ4GTZ89s+RocXtgY7HQGuCebk+Bb4mMq4apsHBjSXZOGJSk/Nj0rOWnmRXLZkFgiVajhYcid7d9EHc9q8+nK/9Xd93+fTG8rUaTj4LDCztvqOrzod3hKohwgS1z7ZqjULan2189wvzIy9HR5E3aeuDxbe8fYbsjB6NWyZjKJILKMGUeUpbRSnafmR1/POe2a0f+6jX+pEfLzTYaLYP3UB6l7d+8ixECCWle+viiKyfaeOHf4NAH88P3ADgAePLT827cj2f8UXyluOmolNzw0oc77bUzMxskfsfJpW798HZGGlYYMEsiRbI15dcuGBkV2+nxjb5ZTG5GWXtw/LwgcYnIrKZZtisNCFts9rpP4WsXKLji+NyyAitLM/2cFmlRt+FRx3oztFeG9fUpEKjH1HW1QVLAxNuerawsr+HUrNOkIjQTIJmZAdiAF2+Dy7MNp+1umvrCBdzNJTjTVJXfwri34uqC+S9UZGkidz9c2fBZSgA6SJ+FkXyoMCVFSNAnDx565RuHLGjUDfF5H82vCNeX2f+4iKoneTEGClEs/3JPkMdSjwXuHFLzYH8Hw2XYF8ZqRWgUnyHvsYacXMsf3+t/WmLw13NEJYEiKVhUk4jF517pt17/6X+r9SVcbs/NRsLHuqPzY9NwDMU9HskbSOEIimmcj1kKN+fmrAgbPHLMDKJ3tjaMfXfxu/5PydSsmmqPhhMoM9joqMG7+4/6BJiy/5yhTm/KtPf3nbwt+fde+SeweFnYLHGNwMCTNHrF9izYw6Rd4ghzqgNO/Hn7HO8qF3qqLlz2hWUXLloaFCxuI6/hxXQaUn7ZPp3SYTKIuEd5XZbvIKAJjXcWK6XWRPUVE5BILC7FQYW3CUWkOwspUE4BT/NGJ4PE1TpmgesSu4rfB6tuQZVZVgCYDZ1Ne274Lb1zMzQsPfhO+dW+FMmOXOf3/hdtJ0LwWsJKhKtxNHoQtAMlA3aWj63Mc/TaSJ9e+5MG/se+Q4973ZSdrewJkiO9ApKSf7O29m63oeKccrRqXu5gCELrC8jh+Prh83sJTz4cjJMzHxtqOrw7tz1+Efr24Epg0FAPQYOyd9Wx7fYzuyi2LUAiCJgNNquCdKFt+teOLcI/LkB6tuOi87unMuc9nsIxXALv6VbFVMAK4E7uk4MBnCk8fAdgc87r6uM384tjTupLYWnj2crOy3hKrCPuNPAGt+S7prvgNv/R9ZT0mFO/Mr92nPHsngMLfTxGtZ0j+tnEj9ytzIhS6YiZltCDPdtc8uiNZhxaR5jWzSaQukauwE7Ponc7/kEr8O/P3+HiXH0TFfwfXkYORfPr6d3Ja1jKQyicFcrKyAJgBZubGEwGCfawGa1xhFKd7tdjTi1RQfoEy/7fJ54OQUkVQsKKuQyGbidK9baagpduSeB0texhGnJyllGE3Tb0lq33NBWnbeG8zcDIm5YQhB0A1NLDy9tn9Kqof35uYV5hWyxwlEmUxNwnIg8sOSUrwmDBk+rdCmoZbElSpmQzmiKmZAaISQz8UP7XnhwrklF5i1/XnfH4d//Sgiiy5G7KX1F4JJF54AQFZds37bIR3ePHxsaXwhXFr5RIm/6P4cMFjzFMFTfxs89bcJq9DHkaKgtelumC1jgfyOhQiHoi7NEEpaslwBmDRSmt84rBxpkIZk5SiPlmwehi2DRJSmLNnWCTnJRARhiCAAU9mqIk/X+BRHVfcfz5446PyVI6ctvfWzGHMMnYTUT+5cm9dn3JUoir7DjkpCxHEDxwQzVcLcDAICVm+s3beYTS1fM/X95HfNw/a8FY7P5WJT80GqWhyMpgNUg3OCTagw3JKd4ntw6RbXSZ7nu+eirzH7sBLE+ySjWYK3pRTDijrqnHV7C/saGta4dW2rrtn5UQnNcdivGLUBeAtDViOpqDaAaPHvWJga0U5Tx849LwycW3L/67KnoV2Ny4Ifr73jptzwrpcsFRoEsBenQA2dCIovYglB4SEd3jz84HQ/XrjkqCgSn0Eye+3EoRPPanfyYDCZUhrJG5yM9p8To8h35kv5E5kxsljIJSJoOvazS9sKIc6UUZle3sufFcMJ2BppBN3nyrcLIqlKKU2QYLAUSipohsjWklx7VdRJVxGndiyGFok9JgZII7BkOEHnTgDTukyJJe9O/STmP5Q2//Fvc3s8/Qjs6Ktw6UXQhUsEoiYLgSMJHEuMicyIxY4UHx8bY2bJVIrKVBRFWgIElRsCXDoQdQDF4BKCSQC6BggKU4qnSOn6ppyPfq2HKTf+5rpv5qyQQieAq+LwZQNs2xItLSnbIEYtc2yESrLeSQBlBF0GXKaGtWlJrkeDoWhdAHDd+m0ppUMr/zl5O/W19+0uWrPMVuFngKp5aJ8EiICQS3i3AijFHEB5AVNaUuC/uLECAChXjUOsJy3NbfTIvpzGjxQAwMjiAS0Z2BqXNdwgfMYkCOQLQxx9XGW7FOxwmooqrx2MeoVLc4Sh5ZBLrNL8xr/1NNdneoY5SUnpkyGnoXBpQk/Wf9S82vPFO9xK2cRINn82Us3DulcLbfpoke/YsrwL/gkA0HrWe5fd+ggYIgRTj7Bbz4oxBwCPkQ9BMcbQNZtSvXlw6yH2GvnQBEjxMYxTTA4zWDE4bMXKCLHHTcXe6IpBzB4WNBuO/E/mlBt/A4D+TflbIVAlVfYxcAiIUiyWNVL8//HywDFDD10QO6lu8dDWcX22uNz6rmYPzWoanXLpkTpfrrsf7ZperQa1ejZ3ZNcfXtfI/KScJ/lnwDA13zJHyYMAwBwoVRhfBjmwShfrL8kjlkl/AYHHgAHhgjLSZkgzI2ynNn9ceNvv8zW+vbC8Fj9f/Z+OhhCevMUH54lkc6YMOj0gkQaoUoGLrBie+knbhEvfZvrde5SQs8xMX054d35fOKgVPRzqq6KyIZkaa6ZWKFziKncz18KiTcGxKtsaVWE0OQPCpR+2VKfpAAARN0lEQVTyNU+arBwH5/444qnjq+SeOxbpC2M2jbx+z/YExGOwnGYg+hl5oR6s+DQytd2U4gnBbeaqrMLWlJYURDQaIY9LwpZ7Ad6vbHk+LKmBmYXHLFQRpw6Kwh4wM+kasS2PrkbJnlx26YvYrd2WOXvUwcOn3Y8anXsCH16OJg/OOis/qj5i/lMnIpma2FfDJ6blhqWfgdaGwNobO6a/POaazmVkjbHz2mL0eevw8crbe2RZW6crlqcm92zFcKW76j+sa+6869q/9VaZGP54LcIbb6pp7JtxiMoNjf1zwACUnhJkf8uXZXK9RXq94T/B09Q29eQKCVkw8O2xkR0Fdd11kyyn0K5jZUcGCUFRJjhsSx9RbHYTAZpHd5TkPMUKQogUVkqQKRZoht5YRZz6SqoizaM/kXRm+jvdpg6zf7rkXX9oY26BcirIncsMs6ZnbeYdzbsUTj14peE3V3T74m+/HV/tcL9nUWPOo8g7+xGIId01+dOW+6kg9CyS3XPY51olDhb2UFLVFulJKezSFrKUutGgxkF7V5abbXW6kFybiyKpCEX9JOGCrkFZNoQgcEk4rxBAkrkfpr4JXRs+oPmMDSljrpU70B31lk/FjUt34MM7Yzl8mz80s19OWE1hUPhEn1kCIAYLr6nlNk83r//p0d7bylMbH5uYYfySAT8qFT0XMT0ehNBtjhmuT+XmRgjSi7xGxhtRp8A3suuMe8tUiNuszk2BBIy+x6G8ZAyJNteZ9dQc1nxbFalfAkmtfzH97aOmnqys6L64TbaMj7lVJ6V5/pPSNvNFuzAa9NTzPq5nuKazVASdLCPNtVi46Q89xdjgPSPtXRjYo/lNw1PPv0kY2lbh0rbJIvt8PcVYama4l8Ijbum37u7J3aYOs5fcNBWh33ND5BYvlyfeEMCaVy+Qtqxrzcnudc6sf3xotnXHTd9fY86jAADXiueQMupSmT7jwX+5n7ksRdROeYMcbsP107brp9V6Bc0yn4Lt7KOo6uSs2HE9HSzqQXmhFjhY0ByF4QzYysVKAbYD0kTJZsSC37NfNk8fkbb0qWY8/OzL01/8+9qUMdfK/Cc+RhP8CrNTgyPM0eyhmdj2rwFzkt3aPUIgFzgidZ1KaIbgfWke7Tu3TpMXPdZnG3WYiNV7CuJWJqqJT9fGxujuLjP6mcL9JZHmaEKPgtUpydt1HASB9zkykAQSWwCUsVPFfe7R1dc11rN/Xg4Vzqw8TFQ/BOHaqIQ7DVDJpKI+kHAAYYBlIaA8pKL1juS5KoUYMUw6WE/ZzYZ/OnubzJa+M9Z5Tn9y13/uJr7h1Yovv+zqD9B56jDsYRZ77v2sqZtlbt7PeUl2UeQ+zdA7an4dZrp7cXhP4EzhElEZlH493V0kNGh2kVULUeWXlpRGivlBwBucPGjRI4G3cTlaDr8W3d++EgAw++wJtVW+M4UdPoeZU2O3LUCCbM2r7wTBdNf2TtEzXU63j4a9AAArHv0CHZ8dUi7doXveh3d8aS+bggc+7siHCmuwZTUiTfjJa2axUj5iUYvzQg2RE7hSRW2BQNRDgsAgB4R9ELQNLmMGujecIdvV313jhn4BECGr/9Pwv30bPA3je+Q0enAWdr1wAVo/PrfOoYB9q1TcjYG6zPDiqAr4GKGn+JETJDOM4jrimHolz1gXhAAB+5I9+vTbe9R4+8FL2ydsvPty/Z24os0kTF4xNM2RgQcY6kqponUYMJmlDqKY8AXhAFziwqMBkBoZhxRkMrNKxCYidGHmGMIzp56v9T8vbTWuTKxX3NkfWX7FaXr+8lWkLF+88qNQUJ6GXxjnrLgyvOX5RiK4pjacUKrSvVEit0uRK0sL/9FHhHaNJSfgJdIAZUNpHrDmySMSIYYqJOH9Tpnps+1GQ7dRNCvX1+SRQuAYNWgl2DR/BUKjF0M2S6/LCjW6fvC3tQBw4PP1yds/XtrWzrIbeRqkaFZh2OUEnENQsh7pGqyscCMVldvc9fyzev90yx4AmN19Avr/WtbzYc2COdqhERsGK4d7a6aoLdxGAQgudz3vPisrNBAk5rvruFc0eKLPJw3aNa6KJRfBF6fD98AlAACHmXQitpj10CvTM2njgS68K+8KVRBKIUDAZdhwZC4EHYIttyPDvyn42oBl9Zu1KWXT2Dt9Iepfcm5VyECjh2acEbLRRjEaC0ZjJnKD2VCMDCIYMRag3S4NyxXQTDF1A/N2xQzJyAAjJASKBLCdBG02Bf/ePFXbtmB0/7B+83dw3iqTurhcvLH8Kozo9BneWnmdaTuBSw1hnklEesgpaElENcBc32G7GRgRJuwQEOt0YW5i5tYKqh2z00CxrGxbI3Qy95ua78tGaR3HDGzxaBlZN27j3B3P+5O3TiisNCCLJaTvtCVmr1/KzeZtL+qSqsgYCOLu5NgtAbs+C88X7Gk4X+meFCLa5bR9Z6WfiIO/P+3xtXgiDADh/NXwpFYtdmhqy4/Q4nyPaXpNp/XzF5eSW5bd9Fly0W+5qQhJsvODQs/0FXZ755o8X9uMCuWbmQNexICZR7OK/HrXNBN5+T4dhqUgXEKTFDkUauUE7KHuzKR53b++/vMqEV2MyI/r4T6/TalzW3fuovR9BcLz6cqk6MFc0lgzqEEai57Ng0lX9CglNxz0/B3pOyfBrFX1bKttR8/EurGlfaaaPzIrzWLSWToiIoVXEERMJcVF+14amNXr2XlJu/NlfVPjvKijELTgYWbb6xLW7WeZuY9e2+cowzaehGsf7oCPR1TFhzD2abbbO8c+f8BBx8gKrjG/3/uq25FBHxj+sCxKZ8BmQn6SVvOwJtA95OTd4xb+WYqjB4ucgreoAiMTkSYM4Vppar6tbZLPubXbaXdGytSJ19D56ewmFN67vdJYdDAcb5OP3b2W/A0AInu/hrt+7Htz4Z1vwdM49jWn4KZHBTn7Da1onwFha9JIC+ef/ZXl3/9vzVX3RmkeY9sIbLoLRoORcPlbJDaKxVh8/cfo9v5RD8/1D09H8rAmaNQ6bk7iUph23RsY9GHF6S0XXjIF506/NW4ZM2P+eZM9rjPSqccbV4dW3PMVOo4fXCX6j0X2kvXI7Nqm0npZ97yDmuMT/7ZhIuj05HQsH3PJSffTYfQsrCr+tMLJ4Nv1j+DSNs8DANYfnEFtag+MO+E/W3tvRkF039XprsZLGvvabVicM7WvJQu/AcqLK2TShGl5tfSHBLQ2N5794R0kytaNzyDzT2tEVuHOSqlnCek/Y3GgxQ1902ve9GdqQv7nsfiLWeg25IIjf6vx12Hub6/C520KJSNm9yZDLACYuGTg27aKDENFcggJw6elTWKolFs7fXlDvO18XEu6U6OfY+z7ApWvIAQFKdL0Xqda+/H/OZQwRTVz/PXoe8ZdJf8eiU502O6NioV0EqCApULnGZrnnlgYQgREpaNu42dWbDEpK5F8DUQEzcqrTemnVRj6Wo1q/BWYsiymNXxt6cX9mWVKJdWJSNvgMVK/9Zk1lzy/qEcZ5gDiMEjez5fA5SIbIjHPYSY9J7p59Kn/MEw1qlFF3Nr5CzAzbBW5CkAlGlgQQRQa5FolnaC6r2f8NFBlGCStZyyXGik7mIjhj2S4rijY8Nea3E8RPvjgg/82CdU4RXhjWUyF/PqyS/sxeCBidpG4IBATRNgU7kxd01XtlCaWSfFzPJSfWZGEKN/V5GhqVhauiHPaiCLglHy59y9BMWPQsGHD/iqHuGr8yRjR+Tu8u+pKT0E0fzCzqo2KogqJIEi3wPhdKbVqQPMx5cbFlB9DUWGQwjFpUdjRZd6PNSqh/38Kw4YNw7Bhw7h6Bfn/B94olj0CVrAvsxyOSoOumKSyUsOq8Iz86L6ygscxKOf7IEwcC18sC9KYNZ/NwlXsCM4RPXy4sv3e/ySGDRv23yahGieJyUsHY0TnL/D6siuaSraf5ZjrSYU7g2J/K0XQ5tzZZcaWiurGZZCiNVekk5Jx93BKuCPKU38V60m7GQJMFFGN79uZ2O1UoxqnBot+fxN/+wa4rctXeHfZsDqWDEyWbLdBIgkbiADQYUN4ZhERnvqx/C8ox2UQd+GhFlyOAZKgfpOZvR9kYCMIIAgPbb6/UUJ3VY1qHINQKFTqbzx8tu6+uOd7tbgFH10GfLDytjoF8uBHiq1+BEok6YMAQ2nC+OGsuiMXAsCTfReUW7mcmPTc5PjZq4ilq7ZS7swC8tTbpTkhxexEBVwtcNx3FapRjcrg9XpRUJRDXq+XZ228Hhe0er9MnavavoxAQb74cvtD9YjcnGnWDl7Y8tG8FVtfN5fkzrz+cHTrQwA3RNkY+HgQujAPSna0NK3RI90bnC9j9o/yE+rHZxDyWkBenAK2yVX3ZUpvdZj2fu6Sht8W0jGR1Dy+g381qlEJUvwZPGfLuCb9Tn98x9frH2nMSjk2AmfV8rRYlRPa4y9wDp72/m/XnxmVoYtMzbUpGN0TfXnx+SN/yv7cQRxX/IrBIAjNK2oNvL7TmzlvLx2G4V0qVtTEZRA77bQ14tC+OGsIKUezFkeT+uR7jPEbofuXcuSQpoxaVf+AXDWqAeDzlTca+eHDGW8uG9I139q/yKN76rCk3G2FS98MOvlnMWSGVLZJIBmVoZ5AkJDYVup4kBCuqBD6C7d2/njd5KVXVcocQBwGyfsA8LX/JN/+semvJIPdSxsLmYTlpKcR7Qitv/UrAaFD2hexu17cCLpqVKMyaJqvQY59sFuEAyPDVmFRwNFMMHkJlOeocC2CcErLFicUtUpEQtdJvHNH5+njx/3UBrd1+SyhhmWE9NTrig2AevKYmDFSgUhn5cp8TQnTRaS6AoBR9LuAcraB6FBRndOqFCBUjWqUYHD7idsjMlhLKruGw1YHW0bOtFWooaWC7QnCxsmH2RIAXUCb6hbJTwHAhU3HJdw4zgd0CKHRgDCSf1JG8oPKrPGS7cocFjrjoYeUu/5TZOf2BABb89uCqJ701l1dW+tSzSDVqDK+WjcKAJDqqjPWIM9lGhnrAGgAKYBOVYZFoZH5gc9Iv2N4p6lZANChfvyvi8VtHO+kft1jAImIMvzjpavmqIi/6Scpta8Pkb/leAhfzMrS+sF8RA5ni9DBQ6fkNqrxfw6D2z6Ht1dci2FnvRW9s+t3C9P0Wv1cWtKkYhnjVGQvEbrwvHZX15n/GN7x0zwA+HDlLVXqIGEinMgeOKuuFqz5O9n+bhudBv1s35YJAxnRHHfHaYsq76Ea1YiPGRuepVxrV8OQzOmhkVHHYvtyxVbjiFNQAxAnssUigKRO5gd3dZt5KwBM2/QgBrV8ocodVfiBnFIV3Q0AQBUe/mGNEdicmuzvcSiy+e49UkUPAYknWKhGNY7HwNaPMoBdv+744sDKrHcfYigIkEbQGLH8kYlOLAEABNprCM/EO7t+/8rFnwGjO32ELk3+dkK0JcwgJUiucWEUwCEA0Bw6oIJbCEA1c1TjhFEUzcFbK65GcbjsuDeWXPa1ghzoMVLbOyrax1LhDDAzQUQYyo3SWZMFYvOYiCifoH/h1dIm3NJ56gYAuLftiyfMHEAV93l2aBcM71GvEmZGDkCZcb72U41qVBWfr7kVV7afgllbRvl1lVEj29rZO9fa94+oE2il2EkjEmEALmKCgiMAgiAtj0hbDGCTIH1OXW/ThVe0mXgidpK4OOHXvp03C0ZaLP66cN9bSK5386miqRr/xzFt4z06KY9RJHPcQTv7dEtZ3Zk5XSOttaVCBw3hPsSgLQTe4CgnX9fNgEme0M0dp0YAYPBMYGSD59Cn1aiTpqV6X1SN/ylM23gvBrV65cjx2yuGIKosIhAENERkIVyaD4LcOD25G/c+/Z5S7b/Z/DQuO/OJv5rsalTj/yb+HwTKOtHrqBcoAAAAAElFTkSuQmCC" />
                                </div> member</span>
                                { this.state.paceyOk ? <i className="icon icon-checkmark-circle icon-for-discount"/> : null }
                                { this.state.paceyWrong ? <i className="icon icon-cross-circle icon-for-discount"/> : null }
                            </label>
                            {this.renderPaceyForm()}
                        </div>
                        <div className="pacey-kinderly">
                            {this.renderTogetherInfo()}
                        </div>
                    </div>
                    <div className="estimated-price">
                        {this.renderEstimatedSubscriptionPricing()}
                        {this.renderEstimatedDiscount()}
                        {this.renderEstimatedVat()}
                        {this.renderEstimatedTotal()}
                    </div>
                </div>
                <DialogActions model={this.state} actions={this.props.actions} onDialogAction={this.handleDialogAction}/>
            </div>
        );

    }
    
})

export default SubscriptionDialog;
